import script from "./AiAgent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiAgent.vue?vue&type=script&setup=true&lang=ts"

import "./AiAgent.vue?vue&type=style&index=0&id=b09cb0cc&lang=scss&scoped=true"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b09cb0cc"]])

export default __exports__